module.exports = __webpack_public_path__ + "static/media/plus_icon.a5b6bc4f.png";